import React, {useState} from 'react';
import {View, StyleSheet, ScrollView, TouchableWithoutFeedback} from 'react-native';

import ScreenOverlay from "./ScreenOverlay";
import ContentSection from "./ContentSection";
import AppText from "./AppText";
import {basicStyles} from "../styles/basic";
import StatusIndicator from "./StatusIndicator";
import ChevronDownSvg from "./svgs/ChevronDownSvg";
import ErrorMiniSvg from "./svgs/ErrorMiniSvg";
import AppPickerInput from "./AppPickerInput";
import AppButton from "./AppButton";
import {objectFlip} from "../utilities/methods";
import {IMPORT_CONFIGURATOR_DESCRIPTION} from "../config";
import AppTextInput from "./AppTextInput";

function ImportConfigurationNoFile({onSubmit, onOffClick, availableColumns, defaultConfiguration = null, description = IMPORT_CONFIGURATOR_DESCRIPTION}) {
	const [state, setState] = useState({
		selectedColumns: {
			...(defaultConfiguration ? defaultConfiguration : {})
		},
	});

	function setColumn(availableColumn, index) {
		setState(prevState => {
			let newState = {...prevState};
			newState.selectedColumns[index] = availableColumn;
			return newState;
		});
	}

	function getColumnTitleByName(name) {
		return availableColumns.find(column => column.name === name)?.title;
	}

	function columnSelected(column) {
		for(let prop in state.selectedColumns) {
			if(state.selectedColumns[prop] === column) {
				return true;
			}
		}

		return false;
	}

	return (
		<ScreenOverlay style={styles.screenWrapper}>
			<TouchableWithoutFeedback onPress={() => onOffClick()}>
				<View style={basicStyles.overlayHidden}/>
			</TouchableWithoutFeedback>
			<ContentSection style={styles.contentSection}>
				<View style={styles.headerWrapper}>
					<View style={{flex: 1}}>
						<AppText>
							Please input the columns input field keys from your Zapier requests under the corresponding field.
						</AppText>
						<AppText>
							If you have any questions, reach out to the Fluid team using the chat in the lower right corner.
						</AppText>
					</View>
				</View>
				<ScrollView
					horizontal={true}
					style={[styles.gridInversion, {marginBottom: 60}]}
					contentContainerStyle={{minWidth: '100%', marginBottom: 30}}
					showsHorizontalScrollIndicator={true}
				>
					<View style={[basicStyles.flexRow, styles.tableWrapper, styles.gridInversion]}>
						{
							availableColumns.map((column, columnIndex) => {
								return (
									<View style={styles.columnWrapper} key={column + '-' + columnIndex}>
										<View style={[
											basicStyles.flexRow,
											basicStyles.alignContentCenter,
											basicStyles.justifyContentSpaceBetween,
											styles.cell,
											styles.columnHeading,
										]}>
											<AppText style={styles.columnHeadingText}>
												{column.title}
											</AppText>
										</View>
										<View style={[styles.cell,]}>
											<AppTextInput
												value={state.selectedColumns[column.name]}
												onChangeText={(value) => setColumn(value, column.name)}
											/>
										</View>
									</View>
								);
							})
						}
					</View>
				</ScrollView>
				<AppButton action={() => onSubmit(state.selectedColumns)} theme="blue" label="Submit"/>
			</ContentSection>
		</ScreenOverlay>
	);
}

export default ImportConfigurationNoFile;

const styles = StyleSheet.create({
	screenWrapper: {
		paddingLeft: 60,
		paddingRight: 60
	},
	contentSection: {
		width: '100%',
		padding: 30,
	},
	tableWrapper: {
		borderWidth: 1,
		borderColor: '#e1e9f6',
		width: '100%'
	},
	cell: {
		padding: 20
	},
	columnValue: {
		whiteSpace: 'no-wrap'
	},
	columnHeading: {
		backgroundColor: '#f8fafe',
	},
	columnHeadingText: {
		fontFamily: 'SourceSansPro-Bold',
		margin: 'auto'
	},
	columnWrapper: {
		borderRightWidth: 1,
		borderColor: '#e1e9f6',
		flexGrow: 1
	},
	headerWrapper: {
		marginBottom: 10,
		flexDirection: 'row',
		alignItems: 'top'
	},
	legend: {
		backgroundColor: 'rgba(221,221,221,.5)',
		borderRadius: 20,
		padding: 10,
		flexDirection: 'row',
		alignItems: 'center'
	},
	legendIcon: {
		marginRight: 10
	},
	legendItem: {
		marginRight: 20
	},
	gridInversion: {
		transform:[{rotateX:'180deg'}]
	},
});
